var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品/条码",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入商品名称或条码查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.search,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "search", $$v)
                                      },
                                      expression: "queryParam.search",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "分类",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-tree-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      dropdownStyle: {
                                        maxHeight: "200px",
                                        overflow: "auto",
                                      },
                                      "allow-clear": "",
                                      treeData: _vm.categoryTree,
                                      placeholder: "请选择分类",
                                    },
                                    model: {
                                      value: _vm.queryParam.categoryId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "categoryId",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.categoryId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "等级",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "allow-clear": "",
                                        placeholder: "只看该等级已设价",
                                      },
                                      model: {
                                        value: _vm.queryParam.levelId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "levelId",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.levelId",
                                      },
                                    },
                                    _vm._l(_vm.levels, function (lv) {
                                      return _c(
                                        "a-select-option",
                                        { key: lv.id, attrs: { value: lv.id } },
                                        [_vm._v(_vm._s(lv.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { gutter: 24 },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  model: {
                                    value: _vm.queryParam.onlySet,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "onlySet", $$v)
                                    },
                                    expression: "queryParam.onlySet",
                                  },
                                },
                                [_vm._v("只看已设置")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchQuery },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.searchReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAddItems },
                        },
                        [_vm._v("添加商品")]
                      )
                    : _vm._e(),
                  _c(
                    "a-button",
                    {
                      attrs: { icon: "download" },
                      on: { click: _vm.handleDownloadTemplate },
                    },
                    [_vm._v("导入模板下载")]
                  ),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "import" },
                          on: { click: _vm.handleImportClick },
                        },
                        [_vm._v("导入")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(3) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "export" },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("a-table", {
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "materialId",
                  columns: _vm.materialColumns,
                  dataSource: _vm.dataSource,
                  pagination: _vm.ipagination,
                  loading: _vm.loading,
                  expandedRowKeys: _vm.expandedRowKeys,
                },
                on: {
                  expandedRowsChange: _vm.onExpand,
                  change: _vm.handleTableChange,
                },
                scopedSlots: _vm._u([
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSaveRow(record)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              )
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c("a-divider", { attrs: { type: "vertical" } })
                            : _vm._e(),
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: {
                                    title:
                                      "移除后该商品全部等级价删除，回退零售价取价，确定？",
                                  },
                                  on: {
                                    confirm: () =>
                                      _vm.handleRemoveItem(record.materialId),
                                  },
                                },
                                [_c("a", [_vm._v("移除")])]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    },
                  },
                  {
                    key: "discountSlot",
                    fn: function (text, record) {
                      return [
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: !record.discountExcluded,
                            checkedChildren: "享受",
                            unCheckedChildren: "排除",
                          },
                          on: {
                            change: (v) => _vm.handleDiscountFlag(record, v),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "expandedRowRender",
                    fn: function (record) {
                      return [
                        _c("a-table", {
                          attrs: {
                            size: "small",
                            bordered: "",
                            rowKey: "extendId",
                            columns: _vm.unitColumns,
                            dataSource: record.units,
                            pagination: false,
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm._l(_vm.levels, function (lv) {
                                return {
                                  key: "price_" + lv.id,
                                  fn: function (text, unit) {
                                    return [
                                      _c("a-input-number", {
                                        key:
                                          "input_" +
                                          lv.id +
                                          "_" +
                                          unit.extendId,
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          min: 0,
                                          precision: 2,
                                          value: _vm.editValue(
                                            unit.extendId,
                                            lv.id
                                          ),
                                        },
                                        on: {
                                          change: (v) =>
                                            _vm.setEdit(
                                              unit.extendId,
                                              lv.id,
                                              v
                                            ),
                                        },
                                      }),
                                    ]
                                  },
                                }
                              }),
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("j-select-material-modal", {
                ref: "selectModal",
                attrs: { multi: true },
                on: { ok: _vm.selectOK },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "导入会员价（CSV）",
                    visible: _vm.importVisible,
                    footer: null,
                    width: "760px",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.importVisible = false
                    },
                  },
                },
                [
                  _c("a-alert", {
                    staticStyle: { "margin-bottom": "12px" },
                    attrs: {
                      type: "info",
                      showIcon: "",
                      message:
                        "文件格式：商品条码,等级名称,会员价（空=清除该等级价）,单位,等级折扣(1=排除)。先下载模板查看样例。",
                    },
                  }),
                  _c("input", {
                    staticStyle: { "margin-bottom": "12px" },
                    attrs: { type: "file", accept: ".csv" },
                    on: { change: _vm.onImportFile },
                  }),
                  _vm.importPreview
                    ? [
                        _c(
                          "a-row",
                          {
                            staticStyle: { "margin-bottom": "8px" },
                            attrs: { gutter: 8 },
                          },
                          [
                            _c("a-col", { attrs: { span: 6 } }, [
                              _vm._v(
                                "新增：" + _vm._s(_vm.importPreview.adds.length)
                              ),
                            ]),
                            _c("a-col", { attrs: { span: 6 } }, [
                              _vm._v(
                                "更新：" +
                                  _vm._s(_vm.importPreview.updates.length)
                              ),
                            ]),
                            _c("a-col", { attrs: { span: 6 } }, [
                              _vm._v(
                                "清除：" +
                                  _vm._s(_vm.importPreview.removes.length)
                              ),
                            ]),
                            _c(
                              "a-col",
                              {
                                staticStyle: { color: "red" },
                                attrs: { span: 6 },
                              },
                              [
                                _vm._v(
                                  "错误：" +
                                    _vm._s(_vm.importPreview.errors.length)
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-height": "260px",
                              overflow: "auto",
                              border: "1px solid #e8e8e8",
                              padding: "8px",
                            },
                          },
                          [
                            _vm._l(_vm.importPreview.errors, function (item) {
                              return _c(
                                "div",
                                {
                                  key: "e" + item.line,
                                  staticStyle: { color: "red" },
                                },
                                [
                                  _vm._v(
                                    "第 " +
                                      _vm._s(item.line) +
                                      " 行：" +
                                      _vm._s(item.message)
                                  ),
                                ]
                              )
                            }),
                            _vm._l(_vm.importPreview.adds, function (item) {
                              return _c("div", { key: "a" + item.line }, [
                                _vm._v(
                                  "第 " +
                                    _vm._s(item.line) +
                                    " 行：新增 " +
                                    _vm._s(item.barcode) +
                                    " " +
                                    _vm._s(item.levelName) +
                                    " = " +
                                    _vm._s(item.price) +
                                    " "
                                ),
                                item.warn
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "orange" } },
                                      [_vm._v("（" + _vm._s(item.warn) + "）")]
                                    )
                                  : _vm._e(),
                              ])
                            }),
                            _vm._l(_vm.importPreview.updates, function (item) {
                              return _c("div", { key: "u" + item.line }, [
                                _vm._v(
                                  "第 " +
                                    _vm._s(item.line) +
                                    " 行：更新 " +
                                    _vm._s(item.barcode) +
                                    " " +
                                    _vm._s(item.levelName) +
                                    " = " +
                                    _vm._s(item.price) +
                                    " "
                                ),
                                item.warn
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "orange" } },
                                      [_vm._v("（" + _vm._s(item.warn) + "）")]
                                    )
                                  : _vm._e(),
                              ])
                            }),
                            _vm._l(_vm.importPreview.removes, function (item) {
                              return _c("div", { key: "r" + item.line }, [
                                _vm._v(
                                  "第 " +
                                    _vm._s(item.line) +
                                    " 行：清除 " +
                                    _vm._s(item.barcode) +
                                    " " +
                                    _vm._s(item.levelName)
                                ),
                              ])
                            }),
                          ],
                          2
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-top": "12px" },
                            attrs: {
                              type: "primary",
                              disabled:
                                _vm.importPreview.adds.length +
                                  _vm.importPreview.updates.length +
                                  _vm.importPreview.removes.length ===
                                0,
                              loading: _vm.importLoading,
                            },
                            on: { click: _vm.confirmImport },
                          },
                          [_vm._v("确认导入")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }